<template>
  <div class="userRightsWrap commonWrap">
    <div class="contentWrap">
      <div style="text-align: right">
        <el-button type="primary"
          v-if="$parent.roleAuthority"
          plain
          icon="el-icon-plus"
          @click="editClick(treeActive)">添加人员</el-button>
        <el-button type="primary"
          @click="exportExcel"
          plain
          v-if="judgeAuthority('houqinguanli:authManager:export')"><i class="el-icon-download el-icon--left"></i>
          EXCEL
        </el-button>
      </div>
      <el-table :data="tableData"
        stripe
        border
        style="width: 100%; margin: 10px 0"
        class="tabWrap"
        height="85%"
        :header-cell-style="{
          'background-color': '#F7F7F7',
        }"
        :cell-style="cellStyle"
        @cell-click="cellClick">
        <el-table-column v-for="(v, i) in tabHead"
          :key="i"
          :prop="v.prop"
          :label="v.label"
          align="center"></el-table-column>
        <el-table-column label="操作"
          width="200"
          align="center"
          v-if="$parent.roleAuthority">
          <template slot-scope="scope">
            <el-button type="text"
              size="small"
              @click="editClick(scope.row)">编辑</el-button>
            <el-button type="text"
              size="small"
              @click="deleteClick(scope.row)">删除</el-button>
            <el-button type="text"
              size="small"
              @click="powerClick(scope.row)">权限</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        style="text-align: right">
      </el-pagination>
    </div>
    <UserDialog v-if="userDialogVisible"
      :activeItem="activeItem"
      :treeAllData="treeAllData" />
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt, judgeAuthority, exportExcelFun } from "@/assets/js/utils";
import UserDialog from "@/components/houqinguanli/quanxianguanli/UserDialog";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  props: ["treeActive", "treeAllData"],
  components: {
    UserDialog,
  },
  data() {
    return {
      userDialogVisible: false,
      tabHead: [
        { label: "姓名", prop: "name" },
        { label: "部门", prop: "departmentName" },
        { label: "电话号码", prop: "phone" },
        { label: "最近登录时间", prop: "loginTime" },
      ],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      activeItem: {},
      defaultUser: false,
    };
  },
  methods: {
    judgeAuthority,
    async getUserList() {
      this.tableData = [];
      if (!this.treeActive.id) {
        return;
      }
      if (this.$parent.showMinaPage) {
        this.$parent.showMinaPage = false;
      }
      this.$store.commit("SET_LOADING", true);
      let res = await api.authorityGetUserList({
        departmentId: this.treeActive.id,
        pageSize: this.page.size,
        page: this.currentPage - 1,
      });
      if (res && res.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data;
        this.page.total = res.data.totalElements;
        this.tableData.forEach((v) => {
          v.loginTime =
            v.latestLoginTime && v.latestLoginTime != 0
              ? dateFtt("yyyy-MM-dd hh:mm", new Date(v.latestLoginTime))
              : "-";
        });
        if (this.defaultUser) {
          this.defaultUser = false;
          this.$store.commit("SET_ACTIVEUSER", {
            id: this.$route.params.userId,
          });
          this.$parent.showMinaPage = true;
        }
      }
    },
    editClick(row) {
      this.activeItem = row;
      this.userDialogVisible = true;
    },
    deleteClick(row) {
      this.$confirm(
        "删除后该用户将不可登录系统和APP,系统中该用户的使用记录将会保留。",
        "删除用户",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          this.$store.commit("SET_LOADING", true);
          let res = await api.authorityDeleteUser({}, row.id);
          if (res && res.data.code == 200) {
            this.$store.commit("SET_LOADING", false);
            if (res.data.data === "cannot delete yourself") {
              this.$message.warning("不能删除自己");
            } else {
              this.$message.success("删除成功");
              setTimeout(() => {
                this.getUserList();
              }, 500);
            }
          }
        })
        .catch(() => {});
    },
    powerClick(row) {
      this.$parent.powerDialogVisible = true;
      let data = {
        user: row,
        department: this.treeActive,
      };
      this.$emit("getActiveItem", data);
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserList();
    },
    cellStyle(row) {
      if (row.column.label === "姓名") {
        return "color:#28CCCB;cursor: pointer;";
      }
    },
    cellClick(row, column) {
      if (column.label == "姓名") {
        this.$store.commit("SET_ACTIVEUSER", row);
        this.$parent.showMinaPage = true;
      }
    },
    exportExcel() {
      if (this.tableData.length == 0) {
        this.$message.error("暂无数据可导出");
        return;
      }
      let title = this.tableData[0].departmentName + "人员表";
      exportFile.xlsxFile(XLSX, title, {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },
  },
  created() {
    this.defaultUser = this.$route.params.userId ? true : false;
  },
};
</script>

<style lang="scss" scoped>
.userRightsWrap {
  @include setCenterWH;
  @include setFlexCenter;
  .contentWrap {
    width: 97%;
    height: 98%;
  }
}
</style>